import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/navigation.css";

const BottomBar = ({ setShowForm }) => {
  const navigate = useNavigate();

  return (
    <div className="bottom-bar">
      {/* Home Button - Navigates to Log Page */}
      <button onClick={() => navigate("/")}>
        <i className="fas fa-home"></i>
        Log
      </button>

      {/* Add Lift Button */}
      <button onClick={() => setShowForm(true)} className="add-lift-button">
        Add Lift
      </button>

      <button>
        Gallery
      </button>
    </div>
  );
};

export default BottomBar;
